import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSearchSearchParams } from 'modules/table';
import { selectFilteredElevatorsCountByState } from '../services/selectors';
import { ElevatorField } from '../types';

export const useElevatorsCountByState = () => {
	const searchParams = useSearchSearchParams();
	const nonStatusSearch = useMemo(
		() => (searchParams?.search ?? []).filter(s => s.field !== ElevatorField.STATUS),
		[searchParams],
	);

	return useSelector(state =>
		selectFilteredElevatorsCountByState(state, {
			search: nonStatusSearch,
		}),
	);
};
